/**
 * FE-only sentinel representing the "All domains" choice in the bank-account form.
 * It is never persisted — an empty/unset domain assignment is what makes an account
 * valid for all domains. See `getRealBankAccountDomains` for the mapping back to the API.
 */
export const ALL_BANK_ACCOUNT_DOMAINS = 'ALL';
